<template>
  <div>
    <div class="row success">
      <div class="col-xl-8">
        <h5 class="mb-4">
          <span style="margin-right: 30px">
            {{ $t("bulletin.notesManquantes") }}</span
          >
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mb-2">
        <label>{{ $t("bulletin.listeClasses") }}</label>
        <a-select
          show-search
          :placeholder="$t('emploi.listeClasses')"
          v-model="selectedClasse"
          style="width: 150px; margin-left: 15px"
          @change="handleClassroomChange"
          :loading="classroomLoading"
          :disabled="classroomLoading"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="classroom in classrooms"
            :key="classroom._id"
            :value="classroom._id"
          >
            {{ classroom.name }}
          </a-select-option>
        </a-select>

        <label style="margin-right: 5px; margin-left: 15px">{{
          $t("emploi.trimestre")
        }}</label>
        <a-select
          :placeholder="$t('paiement.selectionnerMois')"
          style="width: 50px; margin-left: 15px"
          v-model="selectedTrimester"
          @change="handleTrimesterChange"
          default-value="1"
        >
          <a-select-option
            v-for="trimester in ['1', '2', '3']"
            :key="trimester"
            :value="trimester"
          >
            {{ trimester }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div class="row" v-if="selectedClasse && selectedTrimester">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="missingMarksData"
                :loading="tableLoading"
                :pagination="{ pageSize: 10 }"
                rowKey="id"
                :expandedRowRender="expandedRowRender"
              >
                <template slot="teacherName" slot-scope="text">
                  {{ text }}
                </template>
                <template slot="subjectName" slot-scope="text">
                  {{ text }}
                </template>
                <template slot="missingCount" slot-scope="text">
                  <a-tag color="red">{{ text }}</a-tag>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/axios";
import { mapState } from "vuex";

export default {
  name: "MissingMarks",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      classrooms: [],
      selectedClasse: null,
      selectedClassLevel: null, // Add this line to store the selected class level
      selectedTrimester: "1",
      classroomLoading: false,
      tableLoading: false,
      missingMarksData: [],
      columns: [
        {
          title: this.$t("emploi.enseignant"),
          dataIndex: "teacherName",
          key: "teacherName",
          scopedSlots: { customRender: "teacherName" },
        },
        {
          title: this.$t("scolarite.matieres"),
          dataIndex: "subjectName",
          key: "subjectName",
          scopedSlots: { customRender: "subjectName" },
        },
        {
          title: this.$t("scolarite.nombreElevesManquants"),
          dataIndex: "missingCount",
          key: "missingCount",
          scopedSlots: { customRender: "missingCount" },
        },
      ],
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
  },
  async created() {
    await this.getClassrooms();
  },
  methods: {
    expandedRowRender(record) {
      const h = this.$createElement;
      return h(
        "div",
        {
          style: {
            padding: "10px",
            backgroundColor: "#f9f9f9",
            borderRadius: "4px",
          },
        },
        record.studentsWithoutMarks.length > 0 && [
          h(
            "div",
            {
              style: {
                marginBottom: "15px",
                paddingBottom: "10px",
                borderBottom: "1px solid #eaeaea",
              },
            },
            [
              h("a-icon", {
                props: { type: "user" },
                style: {
                  fontSize: "18px",
                  color: "#1890ff",
                  marginRight: "8px",
                },
              }),
              h(
                "span",
                {
                  style: {
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#333",
                  },
                },
                this.$t("menu.liste") + ":"
              ),
            ]
          ),

          [
            h(
              "ul",
              {
                style: {
                  backgroundColor: "white",
                  borderRadius: "4px",
                  listStyleType: "none",
                  padding: 0,
                  margin: 0,
                },
              },
              record.studentsWithoutMarks.map((student) =>
                h(
                  "li",
                  {
                    key: student._id,
                    style: {
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 12px",
                      borderBottom: "1px solid #f0f0f0",
                    },
                  },
                  [
                    h("a-avatar", {
                      props: {
                        size: "small",
                        icon: "user",
                      },
                      style: { marginRight: "10px" },
                    }),
                    h(
                      "span",
                      {
                        style: {
                          fontSize: "14px",
                          color: "#333",
                        },
                      },
                      student.name
                    ),
                  ]
                )
              )
            ),
          ],
        ]
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async getClassrooms() {
      this.classroomLoading = true;
      try {
        const { data } = await apiClient.post("/classrooms/filter", {
          query: {
            status: "active",
          },
          aggregation: {
            $project: {
              _id: 1,
              name: 1,
              level: 1,
            },
          },
        });
        this.classrooms = data;
      } catch (error) {
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.classroomLoading = false;
      }
    },
    async handleClassroomChange() {
      if (this.selectedClasse) {
        const selectedClassroom = this.classrooms.find(
          (classroom) => classroom._id === this.selectedClasse
        );
        if (selectedClassroom) {
          this.selectedClassLevel = selectedClassroom.level;
        }

        if (this.selectedTrimester) {
          await this.fetchMissingMarks();
        }
      }
    },
    async handleTrimesterChange() {
      if (this.selectedClasse && this.selectedTrimester) {
        await this.fetchMissingMarks();
      }
    },
    async fetchMissingMarks() {
      this.tableLoading = true;
      try {
        const { data } = await apiClient.post(
          "/bulletin/v2/mark/missing-marks",
          {
            query: {
              trimester: this.selectedTrimester,
              classRoom: this.selectedClasse,
              schoolarYear: this.settings.activeSchoolarYear,
              type: this.type,
              status: "active",
              level: this.selectedClassLevel,
            },
          }
        );
        this.missingMarksData = data.map((item, index) => ({
          id: index,
          teacherName: item.teacher.name,
          subjectName: item.subject.name,
          missingCount: item.studentsWithoutMarks.length,
          studentsWithoutMarks: item.studentsWithoutMarks,
        }));
      } catch (error) {
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.tableLoading = false;
      }
    },
  },
};
</script>

<style scoped></style>
